// Entry point for the build script in your package.json

// Window animation
import WindowAnimation from "./lib/WindowAnimation";
WindowAnimation.start();

import "./features/externalLinks";
import "./features/nav";
import "./features/pastEvents";

import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);
